/* Pack Code · capa de movimiento.
   - Revelado al entrar en pantalla: cualquier [data-pc-reveal] (o los hijos
     directos de [data-pc-reveal-hijos]) recibe .is-visible con retardo
     escalonado.
   - Parallax suave en los bloques de detalles (.pc-tec__img) y en la foto de
     la seccion marca.
   - Contadores de las cifras (.dl-home-val__cifra) que cuentan al aparecer.
   Todo se desactiva con prefers-reduced-motion. */
(function () {
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducido) { document.documentElement.classList.add('pc-sin-movimiento'); return; }
  document.documentElement.classList.add('pc-con-movimiento');

  // ---- Objetivos de revelado
  var selectores = [
    '.pc-man__cab', '.pc-man__pilar', '.pc-tec__cab', '.pc-tec__etiqueta', '.pc-tec__h', '.pc-tec__p', '.pc-faq__cab', '.pc-faq__item',
    '.dl-ba__cab', '.dl-ba__par', '.dl-vid__titulo', '.dl-home-val__cab', '.dl-home-val__item',
    '.dl-home-marca__texto', '.dl-home-marca__media', '.dl-home-bol__caja', '.pc-cat__tile', '.pc-cat__cab',
    '.dl-prod__cab', '.dl-prod__card', '.pc-compra__galeria', '.pc-compra__panel', '.pc-lh__minis'
  ];
  var nodos = document.querySelectorAll(selectores.join(','));
  var porPadre = new Map();
  nodos.forEach(function (n) {
    n.classList.add('pc-reveal');
    var p = n.parentElement;
    var k = porPadre.get(p) || 0;
    n.style.setProperty('--pc-d', (Math.min(k, 8) * 90) + 'ms');
    porPadre.set(p, k + 1);
  });
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    nodos.forEach(function (n) {
      // Las tarjetas de la comparativa viven en una pista con scroll horizontal:
      // se revelan todas cuando la pista entra en pantalla, no una a una.
      if (n.classList.contains('dl-ba__par')) return;
      io.observe(n);
    });
    document.querySelectorAll('.dl-ba__pista').forEach(function (pista) {
      var io3 = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          pista.querySelectorAll('.dl-ba__par').forEach(function (p) { p.classList.add('is-visible'); });
          io3.disconnect();
        });
      }, { threshold: 0.1 });
      io3.observe(pista);
    });
  } else {
    nodos.forEach(function (n) { n.classList.add('is-visible'); });
  }

  // ---- Parallax
  var capas = Array.from(document.querySelectorAll('.pc-tec__img, .dl-home-marca__media img'));
  var pendiente = false;
  function parallax() {
    pendiente = false;
    var vh = window.innerHeight;
    capas.forEach(function (c) {
      var r = (c.closest('.pc-tec__bloque') || c.parentElement).getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var centro = (r.top + r.height / 2 - vh / 2) / vh; // -1..1
      c.style.transform = 'translate3d(0,' + (centro * -6).toFixed(2) + '%,0) scale(1.12)';
    });
  }
  if (capas.length) {
    capas.forEach(function (c) { c.style.willChange = 'transform'; });
    window.addEventListener('scroll', function () { if (!pendiente) { pendiente = true; requestAnimationFrame(parallax); } }, { passive: true });
    window.addEventListener('resize', parallax);
    parallax();
  }

  // ---- Contadores de cifras
  document.querySelectorAll('.dl-home-val__cifra').forEach(function (el) {
    var txt = el.textContent.trim();
    var m = txt.match(/^([^\d]*)(\d+)([^\d]*)$/);
    if (!m) return;
    var fin = Number(m[2]);
    if (!fin) return;
    var io2 = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io2.disconnect();
        var t0 = performance.now(), dur = 900;
        (function paso(t) {
          var p = Math.min(1, (t - t0) / dur); p = 1 - Math.pow(1 - p, 3);
          el.textContent = m[1] + Math.round(fin * p) + m[3];
          if (p < 1) requestAnimationFrame(paso);
        })(t0);
      });
    }, { threshold: 0.6 });
    io2.observe(el);
  });
})();
